import PLAYER_MODULE_BRIGHTCOVE from 'js-player-module-brightcove';


export default class ScrMovie{

    constructor(){
        this.brightcove = null;
        this.callback = null;
        this._pause = this._pause.bind(this);
        this._resume = this._resume.bind(this);
    }

    init(){
        this.brightcove = videojs('js-brightcove-video');

        this.brightcove.ready(()=>{
            const fullScreenElement = document.getElementsByClassName("vjs-fullscreen-control")[0];
            if(fullScreenElement) fullScreenElement.parentNode.removeChild(fullScreenElement);
            
            const pipElement = document.getElementsByClassName("vjs-picture-in-picture-control")[0];
            if(pipElement) pipElement.parentNode.removeChild(pipElement);
        });

        this.brightcove.on('error', ()=>{
            const error = this.brightcove.error();
            console.log('再生エラーコード:', error.code, 'メッセージ:', error.message);
            this._endAction();
        });
        
        this.brightcove.on('ended', ()=>{
            this._endAction();
        });

        this.brightcove.muted(true);
        this.brightcove.play();
        this.brightcove.pause();
    }
    
    render(callback=null){
        this.callback = callback;
        this._showBrighcove();

        window.addEventListener(PLAYBACK.EVENT.PAGE_PAUSE, this._pause);
        window.addEventListener(PLAYBACK.EVENT.PAGE_RESUME, this._resume);
    }

    dispose(){
        window.removeEventListener(PLAYBACK.EVENT.PAGE_PAUSE, this._pause);
        window.removeEventListener(PLAYBACK.EVENT.PAGE_RESUME, this._resume);
        this.brightcove.dispose();
        this.brightcove = null;
    }
    
    _showBrighcove(){
        document.querySelector('.js-brightcove').classList.add('-active');
        
        try{
            this.brightcove.muted(false);
            this.brightcove.play();
        }
        catch(e){
            this.brightcove.muted(true);
            this.brightcove.play();
        }
    }

    _endAction(){
        document.querySelector('.js-brightcove').classList.remove('-active');
        this.brightcove.pause();
        this.callback();
    }

    _pause(){
        if(!this.brightcove) return;
        this.brightcove.pause();
    }

    _resume(){
        if(!this.brightcove) return;
        this.brightcove.play();
    }
}